import React from 'react'

// react router dom
import { Link } from 'react-router-dom'
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl'

export default function EditShippingFeed(props) {
    // props
    const { categoriesDetails } = props

    // store url
    const [storeUrl] = useStoreUrl()

    return (
        <div className="page-border-box2 mb-3 mb-md-4 edit-senders-info">
            <div className="pbb2-inner d-flex">
                <div className="text-sec media-body pe-3">
                    <div className="app-header-wrapper heading-sm mb-2">
                        <p className="app-heading text-capitalize mb-2">Marketplace category</p>
                        <p className="app-desc st-fs-14">
                            This category is assigned to your products by default. To specify a category for a particular product, go to the “Product / Attributes” page.
                        </p>
                        <p className="app-desc st-fs-14 mt-2">
                            <span className="st-fw-600">Marketplace category: </span>
                            {categoriesDetails?.category}
                        </p>
                    </div>

                </div>

                <div className="btn-sec">
                    <Link to={storeUrl + "/my-sales/google-shopping/settings"} className="st-btn st-btn-sm" style={{ paddingTop: 7.5 }}>
                        Change Category
                    </Link>
                </div>
            </div>
        </div>
    )
}
